import { render, staticRenderFns } from "./AdvancedSearchPeopleCard.vue?vue&type=template&id=565e2ec0&scoped=true&"
import script from "./AdvancedSearchPeopleCard.vue?vue&type=script&lang=js&"
export * from "./AdvancedSearchPeopleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e2ec0",
  null
  
)

export default component.exports